import { Button } from '@/components/ui/button';
import { GiftDTO, useDeleteGift } from '@/hooks/useGifts';
import { Eraser } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogAction,
  AlertDialogFooter,
  AlertDialogDescription,
} from '@/components/ui/alert-dialog';
import LoadingCircle from '@/components/LoadingCircle';

interface DeleteProps {
  gift: GiftDTO;
}

const Delete = ({ gift }: DeleteProps) => {
  const deleteGift = useDeleteGift();

  const handleDelete = async () => {
    await deleteGift.mutateAsync(gift.id.toString());
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="destructive"
          className="bg-red-500 hover:bg-red-600 border-red-600 transition-colors"
        >
          <Eraser className="w-4 h-4" />
          Xóa
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="luxury-dialog">
        <AlertDialogDescription className="sr-only">
          Xác nhận xóa
        </AlertDialogDescription>
        <AlertDialogHeader className="luxury-header">
          <AlertDialogTitle className="luxury-title">
            Xác nhận xóa
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="space-y-6">
          <div className="luxury-card">
            <p className="text-center text-lg">
              Bạn có chắc chắn muốn xóa quà tặng{' '}
              <span className="font-semibold text-luxury-900">{gift.name}</span>
              ?
            </p>
            <p className="text-center text-sm text-luxury-700 mt-2">
              Hành động này không thể hoàn tác.
            </p>
          </div>
        </div>
        <AlertDialogFooter className="mt-6 space-x-4">
          <AlertDialogCancel className="w-[120px] luxury-button-outline">
            Hủy
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="w-[120px] bg-red-500 hover:bg-red-600 text-white transition-colors"
            disabled={deleteGift.isPending}
          >
            {deleteGift.isPending ? <LoadingCircle /> : 'Xóa'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Delete;
